import { useUIDSeed } from 'react-uid'; // eslint-disable-next-line @repo/internal/react/require-jsdoc

export default function useUniqueId(prefix) {
  var seed = useUIDSeed();
  return "".concat(prefix, "-").concat(seed(prefix));
}